
import React from 'react';
import styled, { css } from 'styled-components';
import { Colors } from '.';
import { LFC } from '../Legacy';
import { Icon } from '../concepts/resources/Icon';

const Inner = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    margin: 0 -.25rem;
    user-select: none;
    & > svg {
        margin-right: .5rem;
    }
`;

const CloseFrame = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.2rem;
    height: 1.2rem;
    margin-left: .5rem;
    margin-right: -.25rem;
    border-radius: .25rem;

    svg {
        width: .875rem;
        height: .875rem;
    }

    &:hover {
        cursor: pointer;
        background: rgba(0,0,0,.05);
    }

    &:active {
        cursor: pointer;
        background: rgba(0,0,0,.1);
    }
`;

export const Close: LFC<{ onClick: any }> = ({ onClick }) =>
    <CloseFrame onClick={onClick}>
        <Icon src="deqo://icons/hero/x" />
    </CloseFrame>;

const baseStyle = css`
    display: inline-flex;
    align-items: center;
    min-height: 2.5rem;
    padding: .5rem 1rem;
    margin: .25rem;
    border-radius: .5rem;
    font-weight: 400;
`;

const Base = styled.div<{ canEdit?: boolean, editing?: boolean }>`
    ${baseStyle};
    background: #fff;
    border: solid .125rem ${Colors.primary};
    color: ${Colors.primaryText};

    ${p => !p.canEdit ? '' : css`
        &:hover {
            box-shadow: 0 0 0 .0625rem ${Colors.primary};
        }
        &:active {
            border: solid .125rem ${Colors.primary};
            box-shadow: 0 0 0 .125rem ${Colors.primary};
        }
    `}

    ${p => p.editing ? css` box-shadow: 0 0 0 1px ${Colors.primary}; ` : ''}
`;

export const Pill = Object.assign(Base, { Inner, Close });
